import { SVGProps, Ref, forwardRef } from 'react';

export const HieroglyphLetterOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M.5 2.467h4.633V.5h1.4v1.967h4.634v1.4H8.514C8.43 5.389 8.057 6.92 7.234 8.14q-.153.228-.325.438c.71.426 1.537.697 2.465.72l1.131-3.17h1.654l3.345 9.368h-1.486l-.703-1.967H9.349l-.702 1.967H7.16l1.723-4.825a6.34 6.34 0 0 1-3.04-1.11c-.889.613-2.016.972-3.401.972q-.754-.001-1.417-.139l.284-1.37q.51.107 1.133.108c.929 0 1.68-.193 2.285-.526a8.2 8.2 0 0 1-1.898-3.24l1.342-.4a6.7 6.7 0 0 0 1.637 2.745q.142-.168.266-.353c.626-.93.954-2.164 1.038-3.492H.5zm12.315 9.663-1.483-4.152L9.85 12.13z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
HieroglyphLetterOutlinedSize16Glyph.displayName = 'HieroglyphLetterOutlinedSize16Glyph';
